function BrandCampaignsController() {
    var self = this;

    self.initialise = function() {
    };

    self.initialise();
}

angular
    .module('dashboard')
    .component('brandCampaigns',
        {
            templateUrl: 'components/brand/campaigns/campaigns.42ac1333.html',
            bindings: {},
            controller: [BrandCampaignsController]
        });